// @flow
export const GET_ADM_PROJECTS_BILLABLE_WORKFLOWS_DATA='GET_ADM_PROJECTS_BILLABLE_WORKFLOWS_DATA';
export const GET_ADM_PROJECTS_BILLABLE_WORKFLOWS_DATA_ERROR='GET_ADM_PROJECTS_BILLABLE_WORKFLOWS_DATA_ERROR';
export const GET_ADM_TASKS_COUNT_REPORTS_DATA='GET_ADM_TASKS_COUNT_REPORTS_DATA';
export const GET_ADM_TASKS_COUNT_REPORTS_DATA_ERROR='GET_ADM_TASKS_COUNT_REPORTS_DATA_ERROR';
export const GET_ADM_WORKERS_TASKS_COUNT_REPORT_DATA='GET_ADM_WORKERS_TASKS_COUNT_REPORT_DATA';
export const GET_ADM_WORKERS_TASKS_COUNT_REPORT_DATA_ERROR='GET_ADM_WORKERS_TASKS_COUNT_REPORT_DATA_ERROR';


// WEBPACK FOOTER //
// ./src/redux/adm/actionTypes.js